import React, { FC, useEffect } from "react";
import { useDevicePermissionsStore } from "../../storez/DevicePermissionsStore";
import { useSessionStore } from "../../storez/SessionStore";

const ZendeskSunshine: FC = () => {
  const permissionsLoaded = useDevicePermissionsStore((state) => state.loaded);
  const permissions = useDevicePermissionsStore((state) => state.permissions);
  const device = useSessionStore((state) => state.getDevice());
  const user = useSessionStore((state) => state.getUser());

  const removeForethoughtAIChatbot = () => {
    document.getElementById("forethought-chat")?.remove();
    document.getElementById("forethought-widget-embed-script")?.remove();
  };

  const getLocale = (region: string, timezone: string): string => {
    switch (region) {
      case "us-1":
        if (timezone.includes("Pacific")) return "en-NZ";
        return "en-US";
      case "syd-2":
        return "en-AU";
      case "uk-1":
        return "en-GB";
      default:
        return "en-US";
    }
  };

  useEffect(() => {
    if (!process.env.REACT_APP_FORETHOUGHT_AI_API_KEY) return;

    removeForethoughtAIChatbot();

    if (!device || !user || !permissionsLoaded) return;

    // The following script is available in the ForethoughtAI dashboard
    // ForethoughtAI app link: https://qoria.forethought.app/
    const script = document.createElement("script");
    script.setAttribute("src", "https://solve-widget.forethought.ai/embed.js");
    script.setAttribute("id", "forethought-widget-embed-script");
    script.setAttribute("data-api-key", process.env.REACT_APP_FORETHOUGHT_AI_API_KEY);
    script.setAttribute("data-ft-Device-Id", device.id || "");
    script.setAttribute("data-ft-Email", user.username || "");
    script.setAttribute("data-ft-Locale", getLocale(device.region, device.timezone));
    script.setAttribute("data-ft-workflow-tag", "LW - Filter");
    script.setAttribute("data-ft-user-permissions", permissions.join(",") || "");
    script.setAttribute("data-ft-lw_anz_mentions_linewize", device.region === "uk-1" ? "false" : "true");

    document.head.append(script);

    return () => {
      removeForethoughtAIChatbot();
    };
  }, [device, user, permissionsLoaded, permissions]);

  return <div id="forethoughtAIChatbot"></div>;
};

export default ZendeskSunshine;
